'use client';

import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';

export const AfterPayV2 = () => {
    useConsentGatedInit({
        src: getENV('NEXT_PUBLIC_AFTERPAY_SCRIPT_URL'),
        consentGroup: 'C0001',
    });

    return null;
};
